export const GIT_URL = ENV_GIT_URL;
export const API_URL = ENV_API_URL;
export const CALLBACK_URL = ENV_CALLBACK_URL;
export const ACCESS_TOKEN = 'accessToken';